@let mobileBreakpoint = 375;
@let desktopBreakpoint = 1280;
<div class="relative h-full w-full overflow-hidden">
  <!-- Zoom Controls -->
  <div class="mb-4 flex items-center gap-4">
    <div class="flex gap-2">
      <button type="button" class="rounded px-2 py-1" (click)="zoomOut()">
        −
      </button>
      <input
        type="range"
        min="0.1"
        max="2"
        step="0.1"
        [(ngModel)]="zoom"
        class="w-48" />
      <button type="button" class="rounded px-2 py-1" (click)="zoomIn()">
        +
      </button>
    </div>
  </div>

  <!-- Preview Window with arrows and zoomable content -->
  <div class="relative h-full w-full overflow-hidden rounded">
    @if (components().length > 1) {
      <!-- Left Arrow -->
      <button
        type="button"
        class="material-symbols-rounded absolute top-1/2 left-2 z-10 -translate-y-1/2 px-2 py-1 disabled:opacity-50"
        (click)="prev()"
        [disabled]="currentIndex === 0">
        arrow_back_ios_new
      </button>

      <!-- Right Arrow -->
      <button
        type="button"
        class="material-symbols-rounded absolute top-1/2 right-2 z-10 -translate-y-1/2 px-2 py-1 disabled:opacity-50"
        (click)="next()"
        [disabled]="currentIndex === components().length - 1">
        arrow_forward_ios
      </button>
    }

    <!-- Scrollable and Zoomable Content -->
    <div class="h-full w-full overflow-hidden">
      <div class="flex h-full w-full items-center justify-center">
        <div
          class="origin-center transition-transform duration-200"
          [style.transform]="'scale(' + zoom + ')'">
          <iframe
            #iframe
            class="rounded bg-white shadow"
            [style.width.px]="
              isMobile() ? mobileBreakpoint : desktopBreakpoint
            ">
          </iframe>
        </div>
      </div>
    </div>

    @if (components().length > 1) {
      <div
        class="absolute right-1/2 bottom-16 z-10 flex translate-1/2 -translate-y-1/2 gap-3 rounded px-2 py-1">
        @for (component of components(); track $index) {
          @if ($index === currentIndex) {
            <div class="bg-accessibility-fill h-4 w-4 rounded-full"></div>
          } @else {
            <div class="h-4 w-4 rounded-full border border-gray-500"></div>
          }
        }
      </div>
    }
  </div>
</div>
